// src/hooks/useTabChangeFetch.js
import { useCallback, useEffect, useRef, useState } from "react";

/**
 * initialKey: string
 * onChange: (key) => void|Promise
 *
 * Retorna:
 * - activeKey
 * - setActiveKey (se precisar)
 * - onTabChange (pra passar pro SystemTabs)
 */
export function useTabChangeFetch({ initialKey, onChange } = {}) {
    const [activeKey, setActiveKey] = useState(initialKey || "");
    const first = useRef(true);

    // quando initialKey mudar (ex: profile mudou)
    useEffect(() => {
        if (initialKey && initialKey !== activeKey) setActiveKey(initialKey);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialKey]);

    useEffect(() => {
        // dispara também no primeiro render (carrega a aba inicial)
        if (first.current) {
            first.current = false;
            if (activeKey && typeof onChange === "function") onChange(activeKey);
            return;
        }

        if (activeKey && typeof onChange === "function") onChange(activeKey);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeKey]);

    const onTabChange = useCallback((key) => setActiveKey(key), []);

    return { activeKey, setActiveKey, onTabChange };
}
